import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface BaseAuthCardProps {
  title: string;
  description: string;
  children: ReactNode;
  className?: string;
}

export function BaseAuthCard({ 
  title, 
  description, 
  children, 
  className 
}: BaseAuthCardProps) {
  return (
    <Card className={cn("w-full shadow-xl", className)}>
      <CardHeader className="pb-3 sm:pb-4">
        <CardTitle className="text-xl font-bold text-center tracking-tight sm:text-2xl lg:text-3xl">{title}</CardTitle>
        <CardDescription className="text-center text-xs sm:text-sm">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent className="w-full">
        {children}
      </CardContent>
    </Card>
  );
}
